// extracted by mini-css-extract-plugin
module.exports = {"notificationIcon":"SeriesEmailCapture_notificationIcon__lPnl0"};